<template>
  <div>
    <b-card class="business-card">
      <section id="faq-tabs">
        <b-tabs
          vertical
          content-class="col-12 col-md-8 col-lg-9"
          pills
          nav-wrapper-class="faq-navigation col-md-4 col-lg-3 col-12"
          nav-class="nav-left"
        >
          <!-- configuration tab -->
          <b-tab
            v-for="(item, index) in filteredConfigurations"
            :key="item.name"
            :active="!index"
          >
            <!-- title -->
            <template #title>
              <feather-icon
                :icon="item.icon"
                size="18"
                class="mr-1"
              />
              <span class="font-weight-bold">{{ item.name }}</span>
            </template>

            <component :is="item.component" />
          </b-tab>
        </b-tabs>
      </section>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BTabs, BTab,
} from 'bootstrap-vue'
import ActivateInterbankPayment from './ActivateInterbankPayment.vue'
import EnabledDisabledTransfer from './EnabledDisabledTransfer.vue'
import FeeConfigurationSetup from './FeeConfigurationSetup.vue'
import SettlementGLSetup from './SettlementGLSetup.vue'
import SwitchTransferGateway from './SwitchTransferGateway.vue'
import EasyPaySetup from './EasyPaySetup.vue'
import InterBankProfile from './InterBankProfile.vue'
import ConfigureGatewayCredentials from './ConfigureGatewayCredentials.vue'
import GatewaySettlementsAccount from './GatewaySettlementsAccount.vue'

export default {
  components: {
    BCard,
    BTabs,
    BTab,
    EnabledDisabledTransfer,
    FeeConfigurationSetup,
    SettlementGLSetup,
    SwitchTransferGateway,
    EasyPaySetup,
    InterBankProfile,
    ConfigureGatewayCredentials,
    GatewaySettlementsAccount,
  },
  data() {
    return {
      configurations: [
        {
          name: this.$t('Activate / Deactivate Inward & Outward Transfers'),
          icon: 'ToggleLeftIcon',
          component: ActivateInterbankPayment,
          hasPermission: 'ENABLE_DISABLE_GENERAL_INTERBANK_TRANSFER',
        },
        {
          name: this.$t('Activate / Deactivate Outward Transfers'),
          icon: 'ToggleLeftIcon',
          component: EnabledDisabledTransfer,
          hasPermission: 'ENABLE_DISABLE_GENERAL_INTERBANK_TRANSFER',
        },
        {
          name: this.$t('Fee Configuration Setup'),
          icon: 'PercentIcon',
          component: FeeConfigurationSetup,
          hasPermission: 'CONFIGURE_TRANSFER_FEE',
        },
        {
          name: this.$t('Settlement GL Setup'),
          icon: 'LayersIcon',
          component: SettlementGLSetup,
          hasPermission: 'CONFIGURE_TRANSFER_GL',
        },
        {
          name: this.$t('Switch Transfer Gateway'),
          icon: 'ShuffleIcon',
          component: SwitchTransferGateway,
          hasPermission: 'SWITCH_TRANSFER_GATEWAY',
        },
        {
          name: this.$t('Setup EasyPay Mandate'),
          icon: 'FileTextIcon',
          component: EasyPaySetup,
          hasPermission: 'MANAGE_TRANFER_GATEWAY_CREDENTIAL',
        },
        {
          name: this.$t('Configure Interbank Profile'),
          icon: 'UserCheckIcon',
          component: InterBankProfile,
          hasPermission: 'MANAGE_INTERBANK_PROFILE',
        },
        {
          name: this.$t('Manage Gateway Credentials'),
          icon: 'KeyIcon',
          component: ConfigureGatewayCredentials,
          hasPermission: 'VIEW_TRANSFER_GATEWAY_CREDENTIAL',
        },
        {
          name: this.$t('Gateway Settlement Account Setup'),
          icon: 'KeyIcon',
          component: GatewaySettlementsAccount,
          hasPermission: 'VIEW_TRANSFER_GATEWAY_SETTLEMENT_ACCT',
        },
      ],
    }
  },
  computed: {
    filteredConfigurations() {
      return this.configurations
        .filter(config => !config.hasPermission || this.hasPermission?.(config.hasPermission))
        .map(item => ({
          ...item,
          name: item.name ? this.$t(item.name) : '',
        }))
    },
  },
  methods: {
    hasPermission(permission) {
      const userPermissions = this.$store.state.auth.userData?.permissions || []
      return userPermissions.includes(permission)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-faq.scss';
</style>
